export enum SortingType {
  desc = 'desc',
  asc = 'asc',
}
